import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import React from 'react';

const DisclosureCard = ({ children, ...props }) => {
  return (
    <Disclosure as="div" className="border-b border-gray-200 py-2" {...props}>
      {children}
    </Disclosure>
  );
};

const List = ({ children }) => <div>{children}</div>;

const Button = ({ children, ...props }) => (
  <DisclosureButton
    className="py-3 flex justify-between items-center w-full font-bold text-gray-800"
    {...props}
  >
    {({ open }) => {
      return (
        <>
          <span>{children}</span>

          <ChevronUpIcon className={clsx('w-5 h-5', open ? '' : 'transform rotate-180')} />
        </>
      );
    }}
  </DisclosureButton>
);

const Panel = ({ children }) => <DisclosurePanel className="mb-2">{children}</DisclosurePanel>;

DisclosureCard.List = List;
DisclosureCard.Button = Button;
DisclosureCard.Panel = Panel;

export default DisclosureCard;
